module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_agder_pos.597e1342.png";